// components/LanguageSelector.jsx
import { useTranslation } from "react-i18next";
import { MdLanguage } from "react-icons/md"; // Changed to Material Design icon

/**
 * Language selector component that allows users to switch between supported languages.
 * Provides a dropdown interface for language selection with visual indicators.
 */

/**
 * LanguageSelector component that renders a dropdown menu for language selection.
 * Supports Finnish and English languages with a visual language icon.
 *
 * @returns {JSX.Element} The rendered LanguageSelector component
 */
const LanguageSelector = () => {
  const { i18n } = useTranslation();

  /**
   * Available languages with their display names
   * @type {Array<{code: string, name: string}>}
   */
  const languages = [
    { code: "fi", name: "Suomi" },
    { code: "en", name: "English" },
  ];

  /**
   * Changes the application's current language
   * @param {string} languageCode - The language code to switch to (e.g., 'fi', 'en')
   */
  const changeLanguage = (languageCode) => {
    i18n.changeLanguage(languageCode);
  };

  return (
    <div className="flex items-center gap-1">
      <MdLanguage className="text-[#cabb78] w-5 h-5" />{" "}
      {/* Changed to MdLanguage */}
      <select
        className="languageSelector appearance-none bg-transparent border-none cursor-pointer focus:outline-none"
        value={i18n.language}
        onChange={(e) => changeLanguage(e.target.value)}
      >
        {languages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {lang.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;
